/**
 * @param {{freeSpaceImage:any,tileCategories:any,hide_registeration_form:any}} data
 */
import mockBingoData from "./mock/data/bingo";
import {parseTucData} from "./parse";
import url from "./url";
import $ from "jquery";

const {
  endpoints,
  baseApiUrl: baseUrl,
  baseApiUrlWithoutWin: baseUrlWithoutWin,
} = url;

const getPreparedEndpoint = (endpoint) => {
  let preparedEndpoint = endpoint;

  const searchParams = new URLSearchParams(window.location.search);
  const cb = searchParams.get("cb");

  const hasQueryParams = endpoint.includes("?");

  if (cb) {
    preparedEndpoint = endpoint + '?cb=' + cb;
    if (hasQueryParams === true) {
      preparedEndpoint = endpoint + '&cb=' + cb;
    }
  }

  return preparedEndpoint;
};

const fetchCms = async (endpoint) => {

  let preparedEndpoint = getPreparedEndpoint(endpoint);

  try {
    const response = await fetch(`${baseUrl}${preparedEndpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};
const fetchCmsWithoutWin = async (endpoint) => {
  let preparedEndpoint = getPreparedEndpoint(endpoint);

  try {
    const response = await fetch(`${baseUrlWithoutWin}${preparedEndpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const fetchProfileZipCode = async (val) => {
  try {
    const response = await fetch(`${baseUrl}site-data?zipcode=${val}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      cache: "no-store",
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const postCms = async (endpoint, data) => {
  // TODO:
  try {
    const response = await fetch(`${baseUrl}${endpoint}`, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-store",
      },
      method: "POST",
      mode: "cors",
      cache: "no-store",
      credentials: "same-origin",
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};


const postApi = async (endpoint, data) => {
  try {
    const response = await fetch(
      `${window.location.origin}/win/api/${endpoint}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: JSON.stringify(data),
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }
};

const fetchBingoTiles = async () => {
  try {
    const json = await fetchCms(endpoints.bingo);

    const freeSpace = {
      id: "free-space",
      img: require("./mock/data/bingo/img/tiles/freespace.png"),
    };

    return {
      freeSpace: json.freeSpaceImage.img ? json.freeSpaceImage : freeSpace,
      tilesCategories: json.tileCategories,
    };
  } catch (e) {
    //console.log(e);
    // backup tiles in case of error retrieving tiles
    return mockBingoData();
  }
};

const fetchBingoConfig = async () => {
  try {
    return await fetchCms(endpoints.bingoConfig);
  } catch (e) {
    //console.log(e); // TODO: server error page
    return {};
  }
};

const fetchTossUpChallenge = async () => {
  try {
    const json = await fetchCms(endpoints.tossUp);

    return parseTucData(json);
  } catch (e) {
    //console.log(e);
    return { error: true };
  }
};

const fetchNavigation = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.nav);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchSiteData = async () => {
  try {
    return await fetchCms(endpoints.siteData);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchFooterButtons = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.footer);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

const fetchFooterLinks = async () => {
  try {
    return await fetchCmsWithoutWin(endpoints.footerMenu);
  } catch (e) {
    //console.log(e);
    return {};
  }
};

export const fetchBonusPuzzle = async (id) => {
  try {
    return await fetchCms(
        id === 0
            ? endpoints.bonusPuzzle
            : endpoints.bonusPuzzle + "?solution=" + id
    );
  } catch (e) {
    //console.log(e);
    return { error: e };
  }
};

export const sendUniqueId = async (id) => {
  const data = { uuid: id };
  try {
    return await postCms("create-unique-id?_format=json", data);
  } catch (e) {
    return null;
  }
};
export const sendRegisterInformation = async (uid, uid_sign, uid_time) => {
  const data = {
    sig_timestamp: uid_time,
    uid: uid,
    uid_sig: uid_sign,
  };
  try {
    const json = await postCms("react-drupal-login?_format=json", data);
    //console.log("json", json);
    return json;
  } catch (e) {
    return null;
  }
};

export const fetchGiveaway = async (id) => {
  try {
    return await fetchCms(`${endpoints.featuredGiveaway}/${id}`);
  } catch (e) {
    // //console.log(e);
    return { error: e };
  }
};

export const fetchGiveawayConfirm = async (id) => {
  try {
    return await fetchCms(
        `${endpoints.featuredGiveaway}/${id}/confirmation`
    );
  } catch (e) {
    // //console.log(e);
    return { error: e };
  }
};

const postBonusPuzzleResult = async (data) => {
  try {
    // TODO: v1.1
    return await postCms(endpoints.bonusPuzzle, data);
  } catch (e) {
    //console.log(e);
    return null;
  }
};

const postGiveawaySignup = async (data) => {
  try {
    const json = await postCms("giveaway-entry-data?_format=json", data);
    //console.log("json", json);
    return json;
  } catch (e) {
    return null;
  }
};

const SendIPAddress = async () => {
  /*$.ajax({
    url: "/api/user-location-data/akamai-edgescape",
    cache: false,
    dataType: "json",
    success: async (akamaiEdgescapeLocData) => {
      if (akamaiEdgescapeLocData !== "" && akamaiEdgescapeLocData.success === 1) {
        const json = akamaiEdgescapeLocData;
        if (json.hide_registeration_form === 1) {
          $("body").addClass("hide-registration-form");
        }
        return json;
      }

      $.ajax({
        url: "/api/user-ip-address",
        cache: false,
        dataType: "json",
        success: async function (loc_data) {
          if (loc_data !== "") {
            let _data = loc_data;
            try {
              const json = await postCms("user-location-data?_format=json", _data);
              //console.log("response", json);
              if (json.success === 1 && json.hide_registeration_form === 1) {
                $("body").addClass("hide-registration-form");
              }
              return json;
            } catch (e) {
              return null;
            }
          }
        },
      });

    },
  });*/
  return null
};

const postGiveawayValidation = async (data) => {
  try {
    const json = await postCms(
      "giveaway-entry-data-validation?_format=json",
      data
    );
    //console.log("json", json);
    return json;
  } catch (e) {
    return null;
  }
};

const postApiGiveawaySignup = async (data) => {
  try {
    const json = await postApi("giveaway_signup", data);
    //console.log("json result old", json);
    return json;
  } catch (e) {
    return null;
  }
};

const postApiGiveawaySignupJWT = async (jwt, giveawayId) => {
  try {
    const response = await fetch(
      `/win/api/giveaway_signup_v2`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": jwt,
          "Giveaway-Id": giveawayId,
        },
        method: "POST",
      }
    );

    if (response.ok) {
      return await response.json();
    } else {
      throw response.statusText;
    }
  } catch (e) {
    throw e;
  }


};

export {
  fetchBingoTiles,
  fetchBingoConfig,
  fetchTossUpChallenge,
  fetchNavigation,
  fetchSiteData,
  fetchFooterButtons,
  fetchFooterLinks,
  postBonusPuzzleResult,
  postGiveawaySignup,
  postApiGiveawaySignup,
  postApiGiveawaySignupJWT,
  fetchProfileZipCode,
  postGiveawayValidation,
  SendIPAddress,
};
export default {
  fetchBingoTiles,
  fetchBingoConfig,
  fetchTossUpChallenge,
  fetchNavigation,
  fetchSiteData,
  fetchFooterButtons,
  fetchFooterLinks,
  postGiveawaySignup,
  postApiGiveawaySignup,
  postApiGiveawaySignupJWT,
  fetchProfileZipCode,
  postGiveawayValidation,
  SendIPAddress,
};
